import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import lodashXor from 'lodash/fp/xor';

import log from 'client/lib/log';
import SrImagePreloader from 'client/components/SrImagePreloader';

const debug = log.debug('sunroom:components:SrPhotosCarousel');

class SrPhotosCarousel extends Component {
  static propTypes = {
    photos: PropTypes.arrayOf(PropTypes.string).isRequired,
    onPreviousPhoto: PropTypes.func,
    onNextPhoto: PropTypes.func,
    preloadedPhotos: PropTypes.array,
    disablePhotoCount: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = this._getInitialState(props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (lodashXor(this.props.photos, nextProps.photos).length) {
      this.setState(this._getInitialState(nextProps));
    }
  }

  _getInitialState = (props) => {
    return {
      currentPhotoIndex: 0,
      photosSize: props.photos.length,
      visibleCount: 'hidden',
    };
  }

  _nextPhoto = (e) => {
    e.stopPropagation();
    e.preventDefault();

    const {
      onNextPhoto,
    } = this.props;

    const nextPhotoIndex = this.state.currentPhotoIndex + 1;

    if (nextPhotoIndex >= this.state.photosSize) {
      this.setState({
        currentPhotoIndex: 0,
        visibleCount: 'visible',
      });
      return;
    }

    debug(`nextPhoto: ${nextPhotoIndex + 1}/${this.state.photosSize}`);

    this.setState({
      currentPhotoIndex: nextPhotoIndex,
      visibleCount: 'visible',
    });

    if (onNextPhoto) {
      onNextPhoto(nextPhotoIndex + 1);
    }
  }

  _previousPhoto = (e) => {
    e.stopPropagation();
    e.preventDefault();

    const {
      onPreviousPhoto,
    } = this.props;

    const previousPhotoIndex = this.state.currentPhotoIndex - 1;

    if (previousPhotoIndex < 0) {
      this.setState({
        currentPhotoIndex: this.state.photosSize - 1,
        visibleCount: 'visible',
      });
      return;
    }

    debug(`previousPhotoIndex: ${previousPhotoIndex + 1}/${this.state.photosSize}`);

    this.setState({
      currentPhotoIndex: previousPhotoIndex,
    });

    if (onPreviousPhoto) {
      onPreviousPhoto(previousPhotoIndex + 1);
    }
  }

  _onSkipClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({
      visibleCount: 'visible',
    });
  }

  _onListingPhotosCarouselCtaClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
  }

  render() {
    const {
      photos,
      textOverlay,
      preloadedPhotos,
      disablePhotoCount,
    } = this.props;
    const {
      currentPhotoIndex,
      photosSize,
      visibleCount,
    } = this.state;

    return (
      <div
        className={classNames(
          'SrListingPhotosCarousel',
          visibleCount,
          {
            start: currentPhotoIndex === 0,
            end: currentPhotoIndex + 1 === photosSize,
          }
        )}
      >
        <div className='imageContainer'>
          <img src={photos[currentPhotoIndex]} alt='Listing' />
        </div>
        {preloadedPhotos && preloadedPhotos.length > 0 && (
          <SrImagePreloader imageUrls={preloadedPhotos} />
        )}
        {!disablePhotoCount && (
          <span id='photoCount' className={visibleCount}>
            {currentPhotoIndex + 1} of {photosSize}
          </span>
        )}
        <span className='houseAddress'>
          {textOverlay}
        </span>
        <div className='arrowsContainer'>
          <div
            className='arrow'
            onClick={this._previousPhoto}
          />
          <div
            className='arrow'
            onClick={this._nextPhoto}
          />
        </div>
      </div>
    );
  }
}

SrPhotosCarousel.displayName = 'SrPhotosCarousel';

export default SrPhotosCarousel;
